import { ClipLoader } from 'react-spinners';
import styled from 'styled-components';
import { getStateColor } from "../../utils/getStateColor";
export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  opacity: ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled ? 0.3 : 1;
}};
`;
export const Content = styled.div`
  width: 100%;
  height: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size === 'sm' ? '48px' : size === 'md' ? '76px' : '96px';
}};

  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.secondary;
}};
  border-radius: 10px;
  padding: ${_ref4 => {
  let {
    size
  } = _ref4;
  return size === 'sm' || size === 'md' ? '0 16px' : '0 32px';
}};
  gap: ${_ref5 => {
  let {
    size
  } = _ref5;
  return size === 'sm' || size === 'md' ? '8px' : '12px';
}};

  cursor: ${_ref6 => {
  let {
    disabled
  } = _ref6;
  return disabled ? 'not-allowed' : 'pointer';
}};

  &:hover {
    background-color: ${_ref7 => {
  let {
    theme,
    disabled
  } = _ref7;
  return !disabled && getStateColor(theme.colors.secondary, 'hover');
}};
  }

  &:active {
    background-color: ${_ref8 => {
  let {
    theme,
    disabled
  } = _ref8;
  return !disabled && getStateColor(theme.colors.secondary, 'pressed');
}};
  }
`;
export const SpinnerContainer = styled.div`
  height: ${_ref9 => {
  let {
    size
  } = _ref9;
  return size === 'sm' ? '20px' : size === 'md' ? '24px' : '36px';
}};
  width: ${_ref10 => {
  let {
    size
  } = _ref10;
  return size === 'sm' ? '20px' : size === 'md' ? '28px' : '36px';
}};

  display: flex;
  align-items: center;
  justify-content: center;
`;
export const IconContainer = styled.div`
  height: ${_ref11 => {
  let {
    size
  } = _ref11;
  return size === 'sm' ? '20px' : size === 'md' ? '24px' : '36px';
}};
  width: ${_ref12 => {
  let {
    size
  } = _ref12;
  return size === 'sm' ? '20px' : size === 'md' ? '28px' : '36px';
}};

  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  flex: 1;

  flex-wrap: wrap;
  max-width: 65%;

  user-select: none;
`;
export const Title = styled.p`
  ${_ref13 => {
  let {
    theme,
    size
  } = _ref13;
  return size === 'sm' ? theme.fonts.infoMD : size === 'md' ? theme.fonts.titleXS : theme.fonts.titleMD;
}};
  color: ${_ref14 => {
  let {
    theme
  } = _ref14;
  return theme.colors.neutralL5;
}};
  user-select: none;
  width: fit-content;
  margin: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const Description = styled.p`
  color: ${_ref15 => {
  let {
    theme
  } = _ref15;
  return theme.colors.neutralL5;
}};
  ${_ref16 => {
  let {
    theme,
    size
  } = _ref16;
  return size === 'sm' ? theme.fonts.infoXS : size === 'md' ? theme.fonts.infoSM : theme.fonts.infoMD;
}};
  user-select: none;
  width: fit-content;
  margin: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const ContentRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: ${_ref17 => {
  let {
    size
  } = _ref17;
  return size === 'sm' ? '20px' : size === 'md' ? '28px' : '36px';
}};
  width: ${_ref18 => {
  let {
    size
  } = _ref18;
  return size === 'sm' ? '54px' : size === 'md' ? '67px' : '84px';
}};

  gap: ${_ref19 => {
  let {
    size
  } = _ref19;
  return size === 'sm' ? '4px' : '8px';
}};
`;
export const StyledClipLoader = styled(ClipLoader).attrs(_ref20 => {
  let {
    theme,
    sizeicon
  } = _ref20;
  return {
    color: theme?.colors?.neutralL5,
    size: sizeicon === 'lg' ? 36 : sizeicon === 'md' ? 28 : 20
  };
})`
  position: absolute;
`;
export const Value = styled.p`
  color: ${_ref21 => {
  let {
    theme
  } = _ref21;
  return theme.colors.secondaryL3;
}};
  ${_ref22 => {
  let {
    theme,
    size
  } = _ref22;
  return size === 'sm' ? theme.fonts.textSM : size === 'md' ? theme.fonts.textMD : theme.fonts.textLG;
}};
  user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const Gutter = styled.div`
  height: 8px;
`;